/** Format USD prices without scientific notation for small values. */
export function formatUsdPrice(value: number): string {
  if (!Number.isFinite(value) || value <= 0) return "—";

  if (value >= 1) {
    return `$${value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  }
  if (value >= 0.01) {
    return `$${value.toFixed(4)}`;
  }
  if (value >= 0.0001) {
    return `$${value.toFixed(6)}`;
  }

  const str = value.toFixed(12).replace(/0+$/, "");
  return `$${str}`;
}

export function formatUsdCompact(value: number): string {
  if (!Number.isFinite(value)) return "—";
  if (value > 0 && value < 0.01) {
    return formatUsdPrice(value);
  }
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    notation: "compact",
    maximumFractionDigits: 2,
  }).format(value);
}
